import { Form } from 'antd'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import SuccessMessage from 'utils/SuccessMessage'
import { toCamelCase } from '../../../../utils/camelCase'
import OneToOnePreview from '../../Components/CreateSlotDrawer/OneToOnePreview/index'
import InterviewForm from '../CreateSlotDrawer/InterviewForm'
import AddLocation from './AddLocationDrawer'
import ChangeLocation from './ChangeLocationDrawer'
import CreateSlot from './CreateSlot'
import ManyToManyPreview from './ManyToManyPreview/index'

const CreateSlots = ({
  selectedCandidateId,
  selectedCandidate,
  interViewerList,
  rolesMetrics,
  createSlotDrawer,
  setCreateSlotDrawer,

  driveInterViewerList,

  selectedRound,
  driveData,
  selectedRoundType,
  candidateDeatils,
  candidateInfoData,

  getRoleMetrics,
  setSelectedCandidateId,
  setSelectedCandidate,
  getInterViewLocation,
  isSingleOrBulk,

  getCorporateLocationsList,

  singleLocationData,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  updateLocationAPI,
  addCorporateBranch,
  interviewRoundInfo,
  UpdateScheudle,
  ids,
  setNotification,
  setCandidateInfo,
}) => {
  const RescheduleDriveId = ids?.parameters?.driveId
  const RescheduleRoleId = ids?.parameters?.roleId
  const [form] = Form.useForm()
  const [success, setSuccess] = useState(false)
  const [preview, setPreview] = useState()
  const [checked, setChecked] = useState(null)

  const [schedulePreview, setSchedulePreview] = useState(false)
  const [changeLocationDrawer, setChangeLocationDrawer] = useState(false)
  const [singleLocationChange, setSingleLocationChange] = useState([])
  const [addLocationDrawer, setAddLocationDrawer] = useState(false)
  const [createSloScheduletDrawer, setCreateSloScheduletDrawer] =
    useState(false)
  const [candidates, setCandidates] = useState(0)
  const [selectedRoundName, setSelectedRoundName] = useState(selectedRound)
  const [interviewType, setInterviewType] = useState('')
  const [interviewMode, setInterviewMode] = useState(
    interviewRoundInfo?.mode ?? ''
  )
  const [isOneDayDrive, setIsOneDayDrive] = useState(
    driveData?.startDate === driveData?.endDate
  )
  const [linkPanelData, setLinkPanelData] = useState([
    {
      link: interviewRoundInfo?.link ?? '',
      panel: [{ id: null, firstName: null, lastName: null }],
    },
  ])
  const [addedInterviewer, setAddedInterviewer] = useState([])
  const [dateArr, setDateArr] = useState(interviewRoundInfo?.date ?? '')
  const [interviewInfo, setInterviewInfo] = useState({})
  const [interviewdate, setInterviewdate] = useState({})
  const [interviewTime, setInterviewTime] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [confirmedResponse, setConfirmedResponse] = useState({})

  const [selectingStartDate, setSelectingStartDate] = useState('')
  const [selectingEndDate, setSelectingEndDate] = useState('')
  const [dateRange, setDateRange] = useState([])
  const [selectedLocationId, setSelectedLocationId] = useState('')
  const [locationLoading, setLocationLoading] = useState(false)
  const [pageNo, setPageNo] = useState(1)

  const [locations, setLocations] = useState([])
  const [pageChangeCount, setPageChangeCount] = useState(0)
  const [interviewList, setInterviewList] = useState(driveInterViewerList)
  const [interviewValueInfo, setInterviewValueInfo] = useState({
    duration: interviewRoundInfo?.duration ?? ' ',
    mode: interviewRoundInfo?.mode ?? '',
    timeRange: interviewRoundInfo?.timeRange ?? [],
    instructions: interviewRoundInfo?.instructions ?? '',
  })

  const [timeRange, setTimeRange] = useState([])
  const [linkValue, setLinkValue] = useState(interviewRoundInfo?.link ?? '')
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [interViewData, setInterViewData] = useState([])

  useEffect(() => {
    const firstTime = interviewRoundInfo?.timeRange?.[0]
    const lastTime =
      interviewRoundInfo?.timeRange?.[interviewRoundInfo?.timeRange?.length - 1]
    const data = [firstTime, lastTime]
    setTimeRange(data)
  }, [interviewRoundInfo])

  useEffect(() => {
    loadMoreData()
  }, [pageNo, pageChangeCount])

  const loadMoreData = async () => {
    const { data } = await getCorporateLocationsList({
      pageLimit: 10,
      currentPage: pageNo,
      setLoading: setLocationLoading,
    })

    if (data?.data?.list?.length) {
      const pendingList =
        pageNo == 1
          ? [...(data?.data?.list || [])]
          : [...locations, ...(data?.data?.list || [])]
      setLocations(pendingList)
    } else {
      setLocations([])
    }
  }

  const resetScrollData = () => {
    setPageNo(1)
    setPageChangeCount(prev => prev + 1)
  }

  const order = rolesMetrics[0]?.rounds
    ?.map(({ roundName }) => roundName)
    .indexOf(selectedRoundType?.roundName)

  const isAssesemntType =
    order === 0 && rolesMetrics[0]?.rounds[0]?.type === 'ASSESMENT'

  const dateFormat = 'YYYY-MM-DD'

  const handleIterviewRound = value => {
    setSelectedRoundName(value)
    form.setFieldsValue({
      interviewRound: value,
    })
  }

  const disabledDate = current => {
    let startDate = moment(driveData?.startDate).format(dateFormat)
    let endDate = moment(driveData?.endDate).format(dateFormat)

    return (
      current < moment() ||
      current < moment(startDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const disabledStartDate = current => {
    let assesmentStartDate = moment(driveData?.startDate)
      .subtract(1, 'months')
      .format(dateFormat)
    let endDate = moment(driveData?.endDate).format(dateFormat)
    return (
      current < moment() ||
      current < moment(assesmentStartDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const disabledEndDate = current => {
    let selectedStartDate = moment(selectingStartDate, 'DD/MM/YYYY').format(
      dateFormat
    )
    let endDate = moment(driveData?.endDate).format(dateFormat)

    return (
      current < moment() ||
      current < moment(selectedStartDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const onChangeStartDate = (date, dateString) => {
    setSelectingStartDate(dateString)
    form.setFieldsValue({
      startDate: moment(dateString, 'DD/MM/YYYY'),
    })
  }

  const onChangeEndDate = (date, dateString) => {
    setSelectingEndDate(dateString)
    form.setFieldsValue({
      endDate: moment(dateString, 'DD/MM/YYYY'),
    })
  }

  const onChangeDate = (date, dateString) => {
    setDateRange(date)
    form.setFieldsValue({
      dates: dateString,
    })
  }

  const onMultiChangeDates = dateString => {
    form.setFieldsValue({
      dates: dateString,
    })
  }

  const onChangeTimeRange = dates => {
    const [startTime, endTime] = dates.map(date => date.format('HH:mm'))

    setTimeRange([startTime, endTime])
    form.setFieldsValue({
      timeRange: [startTime, endTime],
    })

    setInterviewValueInfo(prevInfo => ({
      ...prevInfo,
      timeRange: [startTime, endTime],
    }))
  }

  const onDurationChange = value => {
    form.setFieldsValue({
      duration: value,
    })

    setInterviewValueInfo(prevInfo => ({
      ...prevInfo,
      duration: value,
    }))
  }

  const onInstructionsChange = value => {
    form.setFieldsValue({
      instructions: value,
    })

    setInterviewValueInfo(prevInfo => ({
      ...prevInfo,
      instructions: value,
    }))
  }

  const onTimeChange = (value, time) => {
    form.setFieldsValue({
      time: time,
    })
  }

  const onChangeMode = value => {
    form.setFieldsValue({
      mode: value,
    })
    setInterviewValueInfo(prevInfo => ({
      ...prevInfo,
      mode: value,
    }))
  }
  const onChangeLink = e => {
    setLinkValue(e.target.value)
  }

  const onClickNone = () => {
    setAddedInterviewer('None')
    setLinkPanelData([
      {
        panel: [{ id: null, firstName: null, lastName: null }],
      },
    ])
    form.setFieldsValue({
      linkAndPanel: [
        {
          panel: [{ id: null, firstName: null, lastName: null }],
        },
      ],
    })
  }

  const getUpdatedList = () => {
    let selectedInterviewer = linkPanelData
      ?.map(({ panel }) => panel)
      .flatMap(data => data)
      ?.map(({ id }) => id)
    let updatedInterviewerList = driveInterViewerList.filter(
      data => !selectedInterviewer.includes(data?._id)
    )
    setInterviewList(updatedInterviewerList)
  }

  const onSelectInterview = (value, option, index) => {
    let selectedValue = Array.isArray(value) ? value : [value]
    let selectedOption = Array.isArray(option) ? option : [option]
    setAddedInterviewer(
      selectedValue.filter(item => {
        return item !== 'None'
      })
    )

    let selectedData = selectedOption?.map(({ id, firstName, lastName }) => {
      return { id, firstName, lastName }
    })
    let linkAndPanel = linkPanelData.map((data, indx) => {
      if (index === indx) {
        return { ...data, panel: selectedData }
      } else {
        return data
      }
    })

    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const handlePreview = () => {
    if (
      interviewRoundInfo?.interview?.interviewType === 'GROUP' ||
      (interviewRoundInfo?.interview?.interviewType === 'FACE_TO_FACE' &&
        isSingleOrBulk)
    ) {
      setSchedulePreview(true)
      setCreateSlotDrawer(false)
    } else {
      setPreview(true)
      setCreateSlotDrawer(false)
    }
  }

  const getInterViewLocationChange = async () => {
    setIsLoading(true)
    let response = await getInterViewLocation()
    if (response?.status >= 200 && response?.status <= 300) {
      setInterViewData(response?.data?.data?.list || [])
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getInterViewLocationChange()
  }, [])

  useEffect(() => {
    setSelectedRoundName(
      selectedRound === 'all_candidates'
        ? candidateInfoData?.stage
        : selectedRound
    )
    form.setFieldsValue({
      interviewRound:
        selectedRound === 'all_candidates'
          ? candidateInfoData?.stage
          : selectedRound,
    })
  }, [selectedRound, candidateInfoData])

  const getMode = () => {
    setIsOneDayDrive(driveData?.startDate === driveData?.endDate)
    form.setFieldsValue({
      dates: moment(driveData?.startDate, dateFormat),
    })
    if (
      (driveData?.driveMode !== 'VIRTUAL_DRIVE' && interviewType === 'GROUP') ||
      (driveData?.driveMode !== 'VIRTUAL_DRIVE' &&
        interviewType === 'FACE_TO_FACE')
    ) {
      setInterviewMode('OFFLINE')
    } else if (
      driveData?.driveMode === 'VIRTUAL_DRIVE' &&
      interviewType === 'ASSESMENT'
    ) {
      setInterviewMode('EXTERNAL_LINK')
    } else if (interviewType === 'EXTERNAL_ASSESMENT') {
      setInterviewMode('EXTERNAL_LINK')
    } else {
      setInterviewMode(null)
    }
  }

  useEffect(() => {
    getMode()
  }, [driveData, interviewType])

  useEffect(() => {
    form.setFieldsValue({
      mode: interviewMode,
    })
  }, [interviewMode])

  useEffect(() => {
    form.setFieldsValue({
      candidatesPerGroup: candidates,
    })
  }, [candidates])

  useEffect(() => {
    if (!preview) {
      setInterviewType(selectedRoundType?.type)
      form.setFieldsValue({
        interviewType: selectedRoundType?.type,
      })
    }
  }, [selectedRoundType, createSlotDrawer])

  useEffect(() => {
    setInterviewList(driveInterViewerList)
  }, [driveInterViewerList])

  const onSubmitFormData = async values => {
    const dates = [
      moment(dateArr[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
      moment(dateArr[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
    ]

    if (
      interviewRoundInfo?.interview?.interviewType === 'ASSESMENT' ||
      interviewRoundInfo?.interview?.interviewType === 'EXTERNAL_ASSESMENT'
    ) {
      setInterviewInfo({ ...values, dates: dates })
      handlePreview()
    } else {
      setInterviewInfo({ ...values, dates: dates })
    }
    setInterviewdate(values)

    setInterviewTime({ timeRange: timeRange })
    setFormSubmitted(false)
    setPreview(true)
  }

  const getLinkAndPanelValue = value => {
    let updatedList = []
    if (interviewRoundInfo?.mode === 'OFFLINE') {
      updatedList = value.map(({ panel }) => {
        return { panel: panel }
      })
    } else if (
      (interviewRoundInfo?.mode === 'ASSESMENT' ||
        interviewRoundInfo?.interview?.interviewType ===
          'EXTERNAL_ASSESMENT') &&
      interviewRoundInfo?.mode === 'EXTERNAL_LINK'
    ) {
      updatedList = value.map(({ link }) => {
        return {
          link: link,
          panel: [{ id: '', firstName: '', lastName: '' }],
        }
      })
    } else {
      updatedList = value
    }

    return updatedList
  }

  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
    EXTERNAL_ASSESMENT: 'External Assessment',
  }
  const labelText = typeLabels[selectedRoundType?.type] || ''
  const messageType = toCamelCase(labelText)

  const scheduleInterview = async (isConfirm, values) => {
    let isBulk =
      selectedCandidate?.length === 10 ||
      selectedCandidate?.length === candidateDeatils?.candidateList?.count
    let payload = {
      ...values,
      forAllCandidate: isBulk,
      isconfirmed: true,
      interviewType: interviewRoundInfo?.interview?.interviewType,
      duration: interviewValueInfo?.duration,
      candidatesPerGroup:
        interviewType !== 'GROUP' ? 1 : values?.candidatesPerGroup,

      dates: dateArr,
      timeRange: timeRange,
      studentIds: isSingleOrBulk
        ? selectedCandidate.map(data => {
            return { studentId: data?.student?.id }
          })
        : [{ studentId: selectedCandidateId[0] }],
      linkAndPanel: getLinkAndPanelValue(values?.linkAndPanel),
      time: timeRange[0]?.split(' ')[0],
      mode: interviewValueInfo.mode?.includes('EXTERNAL_LINK')
        ? 'EXTERNAL_LINK'
        : interviewValueInfo?.mode,
    }

    let response = await UpdateScheudle(
      ids?.parameters?.driveId,
      ids?.parameters?.studentId,
      payload
    )
    if (response?.status >= 200 && response?.status <= 300) {
      if (isConfirm) {
        SuccessMessage(`${messageType} scheduled successfully!`)
        setCreateSlotDrawer(false)
        form.resetFields()
        form.setFieldsValue({ interviewRound: selectedRoundName })
        form.setFieldsValue({ mode: interviewMode })
        getRoleMetrics(RescheduleDriveId, RescheduleRoleId)
        setSelectedCandidateId([])
        setSelectedCandidate([])
        setSelectingStartDate('')
        setSelectingEndDate('')
        setDateRange([])
        setTimeRange([])
        setLinkPanelData([
          {
            link: '',
            panel: [{ id: null, firstName: null, lastName: null }],
          },
        ])
        form.setFieldsValue({
          mode: interviewMode,
        })
      } else {
        handlePreview()
        setConfirmedResponse(response?.data?.data)
      }
      getMode()

      return true
    } else {
      ErrorMessage(response?.response?.data?.message)
      return false
    }
  }

  const handleLocationData = async payload => {
    if (selectedLocationId) {
      let { status } = await updateLocationAPI({
        payload: payload,
        locationId: selectedLocationId,
      })
      if (status >= 200 && status <= 300) {
        resetScrollData()
        return true
      }
    } else {
      let { status } = await addCorporateBranch({
        payload: payload,
      })
      if (status >= 200 && status <= 300) {
        resetScrollData()
        return true
      }
    }
  }

  const content = () => {
    return (
      <InterviewForm
        form={form}
        createSlotDrawer={createSlotDrawer}
        setCreateSlotDrawer={setCreateSlotDrawer}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        driveInterViewerList={driveInterViewerList}
        driveData={driveData}
        setChangeLocationDrawer={setChangeLocationDrawer}
        changeLocationDrawer={changeLocationDrawer}
        candidateDeatils={candidateDeatils}
        SelectedRoundName={selectedRoundName}
        interviewMode={interviewMode}
        isOneDayDrive={isOneDayDrive}
        linkPanelData={linkPanelData}
        setLinkPanelData={setLinkPanelData}
        addedInterviewer={addedInterviewer}
        interviewInfo={interviewInfo}
        isSingleOrBulk={isSingleOrBulk}
        handleIterviewRound={handleIterviewRound}
        disabledDate={disabledDate}
        onChangeDate={onChangeDate}
        onDurationChange={onDurationChange}
        onTimeChange={onTimeChange}
        onChangeTimeRange={onChangeTimeRange}
        onChangeMode={onChangeMode}
        onChangeLink={onChangeLink}
        onClickNone={onClickNone}
        onSelectInterview={onSelectInterview}
        onSubmitFormData={onSubmitFormData}
        interviewType={interviewType}
        dateFormat={dateFormat}
        candidates={candidates}
        setCandidates={setCandidates}
        selectedRoundType={selectedRoundType}
        preview={preview}
        disabledStartDate={disabledStartDate}
        disabledEndDate={disabledEndDate}
        onChangeStartDate={onChangeStartDate}
        onChangeEndDate={onChangeEndDate}
        selectingStartDate={selectingStartDate}
        selectingEndDate={selectingEndDate}
        isAssesemntType={isAssesemntType}
        dateRange={dateRange}
        interviewList={interviewList}
        getUpdatedList={getUpdatedList}
        isBulk={
          selectedCandidate?.length === 10 ||
          selectedCandidate?.length === candidateDeatils?.candidateList?.count
        }
        interViewData={interViewData}
        checked={checked}
        locations={locations}
        dateArr={dateArr}
        setDateArr={setDateArr}
        singleLocationChange={singleLocationChange}
        setSingleLocationChangeData={setSingleLocationChange}
        onMultiChangeDates={onMultiChangeDates}
        interviewRoundInfo={interviewRoundInfo}
        setInterviewValueInfo={setInterviewValueInfo}
        interviewValueInfo={interviewValueInfo}
        setInterviewMode={setInterviewMode}
        timeRange={timeRange}
        setTimeRange={setTimeRange}
        setLinkValue={setLinkValue}
        linkValue={linkValue}
        formSubmitted={formSubmitted}
        onInstructionsChange={onInstructionsChange}
      />
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          onClick={() => {
            setPreview(false)
            setCreateSlotDrawer(false)
            form.resetFields()
            form.setFieldsValue({ interviewRound: selectedRoundName })
            form.setFieldsValue({ mode: interviewMode })
            setSelectingStartDate('')
            setSelectingEndDate('')
            setDateRange([])
            setTimeRange([])
            getMode()
            setLinkPanelData([
              {
                link: '',
                panel: [{ id: null, firstName: null, lastName: null }],
              },
            ])
            form.setFieldsValue({
              mode: interviewMode,
            })
          }}
          width="88px"
          height="38px"
          text="Cancel"
        />

        <Button.Primary
          height="38px"
          text={'Preview & Confirm'}
          form={'scheduleForm'}
          htmlType={'submit'}
          loading={isLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="43%"
        title={'Reschedule Slots'}
        placement="right"
        visible={createSlotDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setCreateSlotDrawer(false)
        }}
        closable
      />
      {schedulePreview && (
        <ManyToManyPreview
          schedulePreview={schedulePreview}
          setSchedulePreview={setSchedulePreview}
          confirmedResponse={confirmedResponse}
          interviewType={interviewRoundInfo?.interview?.interviewType}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setPrivew={setPreview}
          interviewRoundInfo={interviewRoundInfo}
          interviewValueInfo={interviewValueInfo}
        />
      )}
      <CreateSlot
        createSlotDrawer={createSlotDrawer}
        setCreateSlotDrawer={setCreateSlotDrawer}
        createSloScheduletDrawer={createSloScheduletDrawer}
        setCreateSloScheduletDrawer={setCreateSloScheduletDrawer}
        count={candidateDeatils?.candidateList?.count}
        isBulk={
          selectedCandidate?.length === 10 ||
          selectedCandidate?.length === candidateDeatils?.candidateList?.count
        }
        selectedCandidate={selectedCandidate}
        setPrivew={setSchedulePreview}
        preview={schedulePreview}
        interViewData={interViewData}
        interviewRoundInfo={interviewRoundInfo}
      />
      {changeLocationDrawer && (
        <ChangeLocation
          changeLocationDrawer={changeLocationDrawer}
          setAddLocationDrawer={setAddLocationDrawer}
          addLocationDrawer={addLocationDrawer}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setChangeLocationDrawer={setChangeLocationDrawer}
          interViewerList={interViewerList}
          driveInterViewerList={driveInterViewerList}
          interViewData={interViewData}
          locations={locations}
          getInterViewLocation={getInterViewLocation}
          checked={checked}
          setChecked={setChecked}
          singleLocationChange={singleLocationChange}
          setSingleLocationChangeData={setSingleLocationChange}
          interviewRoundInfo={interviewRoundInfo}
        />
      )}
      {addLocationDrawer && (
        <AddLocation
          changeLocationDrawer={changeLocationDrawer}
          setAddLocationDrawer={setAddLocationDrawer}
          addLocationDrawer={addLocationDrawer}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setChangeLocationDrawer={setChangeLocationDrawer}
          driveInterViewerList={driveInterViewerList}
          interViewData={interViewData}
          locations={locations}
          getInterViewLocation={getInterViewLocation}
          getListOfCountries={getListOfCountries}
          getListOfStates={getListOfStates}
          getListOfCities={getListOfCities}
          listOfCountries={listOfCountries}
          listOfStates={listOfStates}
          listOfCities={listOfCities}
          selectedLocationId={selectedLocationId}
          setSelectedLocationId={setSelectedLocationId}
          handleLocationData={handleLocationData}
          addCorporateBranch={addCorporateBranch}
          setLocationLoading={setLocationLoading}
          singleLocationData={singleLocationData}
          interviewRoundInfo={interviewRoundInfo}
          locationLoading={locationLoading}
        />
      )}
      {preview && (
        <OneToOnePreview
          interviewInfo={interviewInfo}
          interviewTime={interviewTime}
          interviewdate={interviewdate}
          dateArr={dateArr}
          interviewValueInfo={interviewValueInfo}
          driveInterViewerList={driveInterViewerList}
          isSingleOrBulk={isSingleOrBulk}
          selectedCandidate={selectedCandidate}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setPrview={setPreview}
          scheduleInterview={scheduleInterview}
          preview={preview}
          isOneDayDrive={isOneDayDrive}
          setInterviewType={setInterviewType}
          isLoading={isLoading}
          candidateInfoData={candidateInfoData}
          confirmedResponse={confirmedResponse}
          count={candidateDeatils?.candidateList?.count}
          isBulk={
            selectedCandidate?.length === 10 ||
            selectedCandidate?.length === candidateDeatils?.candidateList?.count
          }
          interviewRoundInfo={interviewRoundInfo}
          setSuccess={setSuccess}
          success={success}
          setNotification={setNotification}
          setCandidateInfo={setCandidateInfo}
          selectedRoundType={selectedRoundType}
        />
      )}
    </>
  )
}

export default CreateSlots
